export class Deferred<T> {

    resolve: (value: T | PromiseLike<T> ) => void;
    reject: any;
    promise: Promise<T>;

    constructor() {
        this.promise = new Promise<T>((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        })
    }
}